import React from "react";
import "./home.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

// Import Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";
import { FaPiggyBank, FaCoins, FaMoneyCheckAlt, FaCar } from "react-icons/fa";

function Home() {
  const sliderImages = [
    "/images/slider1.jpg",
    "/images/slider2.jpg",
  ];

  return (
    <>
      {/* Image Slider */}
      <Swiper
        modules={[Autoplay]}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop={true}
        pagination={false}
        navigation={false}
        className="home-slider"
      >
        {sliderImages.map((img, index) => (
          <SwiperSlide key={index}>
            <img src={img} alt={`slide-${index}`} className="slider-image" />
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Hero Banner */}
      {/* <div className="hero-banner">
        <h1>श्री लक्ष्मी पतसंस्था, अगळगाव</h1>
        <p>आपल्या सेवा, आपल्या विश्वासाची हमी</p>
      </div> */}

      {/* Notice Section */}
      {/* <section className="notice-section">
        <h3>वेळापत्रक सूचना</h3>
        <p>दर शुक्रवारी संस्था बंद राहील आणि दर गुरुवारी 10.00 AM ते 3.00 PM पर्यंत चालू राहील.</p>
        <a href="#" className="notice-link">अधिक सूचना पाहण्यासाठी येथे क्लिक करा.</a>
      </section> */}

      {/* About and Features Section */}
      <section className="about-section">
        <div className="about-left">
          <h2>पतसंस्थेबद्दल</h2>
          <p>
            ⁠जिजाई महिला बचत गटातुन जिजाई अर्बन को-ऑप. क्रेडिट सोसा. लि. जत या पतसंस्थेची निर्मिती झाली. 
            दि. 05/02/2024 रोजी संस्थापक श्री सुरेश एम. सायगांव साहेब व चेअरमनसो सौ सुप्रिया गणेश काळे (कोळी) 
            यांनी 550000/- भांडवल आणि 500 सभासदांसह याची सुरुवात केली. यशस्वी उद्योजक घडवणे महिला सशक्तिकरण करणे, 
            महिला उद्योजक घडवणे असे अनेक संकल्प ठेऊन आम्ही कार्यरत आहोत. 
            आपुलकीची सेवा आणि खूप मोठी विश्वासाची थाप या जोरावर संस्थेने नुकताच 3 कोटीच्या एकत्रित व्यवसायाचा टप्पा पार 
            केला आहे. सर्वोत्तम व्यवस्थापन, विश्वासार्हता, नवीनतम-तंत्रज्ञान आणि सामाजिक बांधिलकी हे सर्व जिजाई अर्बनच्या 
            यशमागील रहस्य आहेत. तुमच्यासाठी सर्वोत्तम साध्य करण्यासाठी आम्ही आमचे सर्वोत्तम देणे सुरू ठेवू.
            {/* <a href="about" className="more-link">अधिक माहिती</a> */}
          </p>
        </div>
      </section>

        {/* <div className="about-right">
          <h3>संस्थेची ठळक वैशिष्ट्ये</h3>
          <ul>          
            <li> संपूर्ण संगणकीकृत बँकिंग प्रणाली.</li>
            <li> ३६५ दिवस सुरु असणारी पतसंस्था</li>
            <li> RTGS/NEFT/IMPS सेवा उपलब्ध.</li>
            <li> 2500+ समाधानी ग्राहक.</li>
            <li> सतत ऑडिट वर्ग ‘अ’.</li>
            <li> दरवर्षी लाभांश देणारी पतसंस्था.</li>
            <li> संपूर्ण संगणकीकृत कामकाज.</li>
            <li> एस.एम.एस. सुविधा.</li>
          </ul>
        </div> */}

      
      <section className="highlights">
        <h2>संस्थेची ठळक वैशिष्ट्ये</h2>
      <div className="highlights-content">
        <ul>
          <li>QR Code सेवा उपलब्ध.</li>
          <li>2500+ सभासदांची पाहुण.</li>
          <li>अल्पवधी व सोपे कर्जप्रक्रिया सह कर्ज वाटप.</li>
          <li>बिजाई महिला सबलीकरण योजना.</li>
        </ul>
        <ul>
          <li>परिपूर्ण वर्षाभरात सभासदांना १५% डिव्हिडंड देण्याचा मान.</li>
          <li>संपूर्ण ठेवीदारांसाठी विमा योजना.</li>
          <li>दर शनिवार व रविवारही ही बँक आपल्या सेवेत उपलब्ध आहे.</li>
          <li>RTGS/NEFT/IMPS सेवा उपलब्ध.</li>
        </ul>
      </div>
    </section>


        {/* Notice Section
      <section className="notice-section">
        <h3>वेळापत्रक सूचना</h3>
        <p>दर शुक्रवारी संस्था बंद राहील आणि दर गुरुवारी 10.00 AM ते 3.00 PM पर्यंत चालू राहील.</p>
        <a href="#" class
        Name="notice-link">अधिक सूचना पाहण्यासाठी येथे क्लिक करा.</a>
      </section> */}


          <section className = "yearly-report">
        <div className="report">
          <h3>वार्षिक अहवाल</h3>
          <p>⁠
            संस्थेच्या सर्व सभासदांना कळविण्यात येते की संस्थेची ४३ वी वार्षिक सर्वसाधारण सभा गुरुवार दि.५-९-२०२३ रोजी दुपारी 
            ४.०० वाजता मराठा चेंबर्स ऑफ कॉमर्स, पद्मजी हॉल, स्वारगेट कॉर्नर, टिळक रोड, पुणे - ४११००२ येथे आयोजित 
            करण्यात आली आहे. तरी सर्व सभासदांनी वेळेवर उपस्थित राहून सहकार्य करावे.
          </p>
        </div>
      </section>


      {/* Loan Icons Section */}
     <section className="loan-icons">
  <div className="loan-i">
    <FaMoneyCheckAlt className="loan-img" />
    <p><strong>12%</strong><br />मुदत ठेवी</p>
  </div>
  <div className="loan-ic">
    <FaPiggyBank className="loan-img" />
    <p><strong>6%</strong><br />बचत खाते</p>
  </div>
  <div className="loan-ico">
    <FaCoins className="loan-img" />
    <p><strong>12%</strong><br />सोने तारण</p>
  </div>
  <div className="loan-icon">
    <FaCar className="loan-img" />
    <p><strong>16%</strong><br />वाहन कर्ज</p>
  </div>
</section>

      {/* Services Arrow Section */}
      <section className="our-services">
        <h3>आमच्या सेवा</h3>
        <p>सर्व बँकिंग सेवा एकाच छताखाली पुरवल्या जातात. काही ठळक सेवा खालीलप्रमाणे :</p>
        <div className="arrow-container">
          <div className="arrow green">
            <div className="arrow-title">शेअर्स</div>
            <div className="arrow-number">1</div>
            <p><strong>शेअर्स मधील गुंतवणूक</strong><br />संस्था गेली काही वर्षे सातत्याने १५ % डिव्हिडंड (लाभांश) देत आहे. नॉन ट्रान्स्फरेबल (विनाहस्तांतरित) शेअर्स मध्ये किमीत कमी रु. १०००.</p>
          </div>
          <div className="arrow blue">
            <div className="arrow-title">ठेवी</div>
            <div className="arrow-number">2</div>
            <p><strong>ठेवी योजना</strong><br />ग्राहकांच्या गरजा लक्षात घेऊन संस्था विविध डिपॉझिटस स्कीम (ठेव योजनां) राबवते. कमी तसेच जास्त अवधीच्या या योजनांवर.</p>
          </div>
          <div className="arrow red">
            <div className="arrow-title">कर्ज</div>
            <div className="arrow-number">3</div>
            <p><strong>सुलभ कर्ज</strong><br />एक जबाबदार वित्तीय पतसंस्थेचे कर्तव्य पार पाडताना कर्जाचे कारण, तारण व परतफेड ह्या बाबी लक्षात घेऊनच संस्था कर्ज देते.</p>
          </div>
        </div>
      </section>

      <section className="scheme">
        <h3>ठेव योजना</h3>
      <div className="scheme-container">
      {/* First button group */}
      <div className="scheme-group">
        <button className="scheme-main">मुदत ठेव योजना</button>
        <button className="scheme-info">अधिक माहिती → </button>
      </div>

      {/* Second button group */}
      <div className="scheme-group">
        <button className="scheme-main">रिकरिंग (आवर्ती) योजना</button>
        <button className="scheme-info">अधिक माहिती → </button>
      </div>
    </div>
      </section>

      <section className="loan-scheme">
      <h3>कर्ज योजना</h3>
      <div className="scheme-container">
      {/* First button group */}
      <div className="scheme-group">
        <button className="scheme-main">सोने तारण कर्ज</button>
        <a href="http://localhost:3000/sone-taran-karj">
        <button className="scheme-info">अधिक माहिती → </button>
        </a>
      </div>

      {/* Second button group */}
      <div className="scheme-group">
        <button className="scheme-main">वाहन तारण कर्ज</button>
        <a href="http://localhost:3000/vahan-taran-karj">
        <button className="scheme-info">अधिक माहिती → </button>
        </a>
      </div>

      <div className="scheme-group">
        <button className="scheme-main">मॉर्गेज तारण कर्ज</button>
        <a href="http://localhost:3000/mortgage-karj">
        <button className="scheme-info">अधिक माहिती → </button>
        </a>
      </div>

      <div className="scheme-group">
        <button className="scheme-main">गृह कर्ज</button>
        <a href="http://localhost:3000/grah-karj">
        <button className="scheme-info">अधिक माहिती → </button>
        </a>
      </div>

      <div className="scheme-group">
        <button className="scheme-main">सभासद कर्ज</button>
        <a href="http://localhost:3000/sabhasad-karj">
        <button className="scheme-info">अधिक माहिती → </button>
        </a>
      </div>
    </div>
</section>


<section className="gallery-section">
  <div className="gallery-container">
    <div className="gallery-card">
      <img src="/images/gold.jpg" alt="Gold Scheme" />
    </div>
    <div className="gallery-card">
      <img src="/images/money.jpg" alt="Money Scheme" />
    </div>
  </div>
</section>
      
    </>
  );
}

export default Home;


